type DataTableApi = {
  page: {
    len: (length?: number) => number | DataTableApi;
  };
  draw: (resetPaging?: boolean | string) => DataTableApi;
};

type JQueryDataTable = {
  DataTable: () => DataTableApi;
};

type JQueryWithDataTable = {
  fn: {
    DataTable: {
      isDataTable: (selector: string) => boolean;
    };
  };
  (selector: string): JQueryDataTable;
};

export function applyDataTablesPageLength(select: HTMLSelectElement, value: string): boolean {
  const tableId = select.getAttribute('aria-controls');
  const jquery = (window as Window & { $?: JQueryWithDataTable }).$;

  if (!tableId || !jquery?.fn?.DataTable?.isDataTable(`#${tableId}`)) {
    return false;
  }

  const length = Number.parseInt(value, 10);
  if (Number.isNaN(length)) {
    return false;
  }

  const table = jquery(`#${tableId}`).DataTable();
  if (table.page.len() === length) {
    if (select.value !== value) {
      select.value = value;
    }
    return true;
  }

  table.page.len(length);
  table.draw();
  return true;
}
